import * as React from 'react';
import { Menu, Button, Responsive } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import Cart from './components/Cart';
import DefaultHeader from './components/DefaultHeader';
import MobileMenu from './components/MobileMenu';
import { getWidth } from './helpers/getWidth';

function UnauthenticatedMenu(_ref) {
  var showLogin = _ref.showLogin,
      publicNav = _ref.publicNav,
      navMenuOpen = _ref.navMenuOpen,
      megaMenuOpen = _ref.megaMenuOpen,
      cartItems = _ref.cartItems,
      cartIcon = _ref.cartIcon,
      logoUrl = _ref.logoUrl,
      children = _ref.children,
      removeFromCart = _ref.removeFromCart,
      onToggleNavMenu = _ref.onToggleNavMenu,
      onNavigate = _ref.onNavigate,
      _ref$mobileBreakpoint = _ref.mobileBreakpoint,
      mobileBreakpoint = _ref$mobileBreakpoint === undefined ? 1000 : _ref$mobileBreakpoint;

  var HeaderRight = function HeaderRight() {
    return showLogin ? React.createElement(
      Button,
      {
        as: Link,
        to: '/login',
        className: 'mobile-menu__login am_banner_login'
      },
      'Log In'
    ) : React.createElement('div', null);
  };

  var HeaderCenter = function HeaderCenter() {
    return React.createElement(DefaultHeader, {
      onToggleNavMenu: onToggleNavMenu,
      logoUrl: logoUrl,
      onNavigate: onNavigate,
      mobileBreakpoint: mobileBreakpoint
    });
  };

  var MobileDropdown = function MobileDropdown() {
    return React.createElement(
      React.Fragment,
      null,
      children
    );
  };

  var MobileFooter = function MobileFooter() {
    return React.createElement(
      React.Fragment,
      null,
      cartItems ? React.createElement(Cart, {
        cartItems: cartItems,
        cartIcon: cartIcon,
        removeFromCart: removeFromCart,
        displayForMobile: true
      }) : null
    );
  };

  return React.createElement(
    'div',
    { 'data-testid': 'unauthenticated-menu' },
    React.createElement(
      Responsive,
      { maxWidth: mobileBreakpoint, getWidth: getWidth },
      React.createElement(MobileMenu, {
        navMenuOpen: navMenuOpen,
        onNavigate: onNavigate,
        onToggleNavMenu: onToggleNavMenu,
        headerCenter: React.createElement(HeaderCenter, null),
        headerRight: React.createElement(HeaderRight, null),
        items: React.createElement(MobileDropdown, null),
        footer: React.createElement(MobileFooter, null)
      })
    ),
    React.createElement(
      Responsive,
      { minWidth: mobileBreakpoint + 1, getWidth: getWidth },
      React.createElement(
        Menu,
        {
          borderless: true,
          fixed: 'top',
          stackable: true,
          className: 'nav-menu ' + (publicNav ? 'nav-menu--small' : 'nav-menu--small') + ' ' + (navMenuOpen ? 'nav-menu--open' : '') + ' ' + (megaMenuOpen ? 'nav-menu--mega-menu-open' : '')
        },
        React.createElement(
          Menu.Item,
          { header: true, fitted: true, className: 'nav-menu__header' },
          React.createElement(DefaultHeader, {
            onToggleNavMenu: onToggleNavMenu,
            logoUrl: logoUrl,
            onNavigate: onNavigate
          })
        ),
        publicNav && children,
        React.createElement(
          Menu.Menu,
          { position: 'right' },
          cartItems && React.createElement(Cart, {
            cartItems: cartItems,
            cartIcon: cartIcon,
            removeFromCart: removeFromCart,
            displayForMobile: false
          }),
          React.createElement(
            Menu.Item,
            null,
            showLogin && React.createElement(
              Button,
              {
                as: Link,
                to: '/login',
                className: 'show-for-small am_banner_login'
              },
              'Log In'
            )
          )
        )
      )
    )
  );
}

export default UnauthenticatedMenu;